<template>
    <section>
        <div class="container">
            <div class="col-unique">
                <img class="logo-brand" src="@/assets/img/logo-brand.png" alt="Logo LG Lugar de Gente">
                <nav>
                <ul>
                    <li @click="goPage('#page4')">QUEM SOMOS</li>
                    <li @click="goPage('#page5')">BENEFÍCIOS</li>
                    <li @click="goPage('#page6')">SOLUÇÕES</li>
                    <li @click="goPage('#page7')">METODOLOGIAS</li>
                    <li @click="goPage('#page10')">DEPOIMENTOS</li>
                </ul>
                </nav>
                <button class="btn-gradient" @click="goPage('#formcard')">SOLICITAR CONTATO</button>
                
            </div>
            <div class="mobilemenu">
                <div class="header__hamburger" @click="toggleMenu()" :class="{click: menuStatus}">
                    <div>
                        <div class="bar hamburger__bar1"></div>
                        <div class="bar hamburger__bar2"></div>
                        <div class="bar hamburger__bar3"></div>
                    </div>
                </div>
            </div>
            <transition name="fade">
            <div class="mobilenav" v-if="menuStatus">
                <ul>
                    <li @click="goPage('#page4')">QUEM SOMOS</li>
                    <li @click="goPage('#page5')">BENEFÍCIOS</li>
                    <li @click="goPage('#page6')">SOLUÇÕES</li>
                    <li @click="goPage('#page7')">METODOLOGIAS</li>
                    <li @click="goPage('#page10')">DEPOIMENTOS</li>
                </ul>
            </div>
            </transition>
        </div>
    </section>
</template>
<script>
export default {
    data() {
        return {
            menuStatus: false
        }
    },
    methods: {
        toggleMenu() {
            this.menuStatus = !this.menuStatus;
        },
        goPage(value) {
            this.menuStatus = false;
            // this.$scrollTo(value);
            this.$emit("unlockAll")
            this.sleep().then(() => {
                this.$nextTick(() => {
                    this.$scrollTo(value, {
                        offset: 0
                    });
                });
            })
        },
        sleep: function (ms = 100) {
            return new Promise(resolve => setTimeout(resolve, ms))
        }
    }
}
</script>
<style lang="scss" scoped>
section {
    // background: rgb(0,0,0);
    // // background: linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%);

    // background: linear-gradient(0deg, rgb(115,29,216) 5%, rgba(0,0,0,1) 100%);
    background-color: white;

    
    position: fixed;
    width: 100%;
    z-index: 10000;
    box-shadow: 0px 5px 15px 0px rgba(0,0,0,.5);
    .container {
        
        height: 130px;
        .col-unique {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            flex-grow: 1;
            align-items: center;
        }
        .logo-brand {
            max-width: 200px;
        }
        nav {
            ul {
                color: $color-text-dark;
                list-style-type: none;
                margin: 0;
                padding: 0;
                display: flex;
                gap: 20px;
                li {
                    display: inline;
                    cursor: pointer;
                    user-select: none;
                }
                
            }
        }
        .mobilemenu {
            display: none;
        }
        .mobilenav {
            // font-size: 1rem;
            position: absolute;
            background-color: white;
            top: 76px;
            width: 100%;
            padding: 20px 30px;
            ul {
                color: $color-text-dark;
                list-style-type: none;
                margin: 0;
                padding: 0;
                display: flex;
                flex-direction: column;
                gap: 30px;
                li {
                    display: inline;
                    cursor: pointer;
                    user-select: none;
                }
                
            }
        }
    }
    @media only screen and (max-width: 1140px) {
        .container {
            height: 76px;
            .col-unique {
                margin-right: 10px;
            }
            nav {
                display: none;
            }
            .logo-brand {
                max-width: 150px;
            }
            .btn-gradient {
                height: 40px;
                font-size: .7rem;
                padding: 0 7px;
                box-shadow: 0px 5px 8px 0px rgba(34,0,80,0.6);
            }
            .mobilemenu {
                display: block;
                width: 40px;
                margin-right: 15px;
                position: relative;
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
        opacity: 0;
    }
}
</style>